// Maps the "how recent" release filter tokens to a concrete release_date range
// the backend can apply directly. Values are ISO date strings (YYYY-MM-DD) or
// null when that bound is open-ended.
//
// Tokens are shared with the release filter <select> in SearchBarC.

export const RELEASE_WINDOW_OPTIONS = [
  { value: "", label: "Any time" },
  { value: "this_month", label: "Released this month" },
  { value: "6_months", label: "Last 6 months" },
  { value: "1_year", label: "Last year" },
  { value: "5_years", label: "Last 5 years" },
  { value: "older", label: "Older games" },
];

// Format a Date as YYYY-MM-DD using LOCAL calendar parts (not UTC) so month
// boundaries don't shift a day in timezones behind/ahead of UTC.
const toISODate = (date) => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
};

export function releaseWindowToRange(token) {
  if (!token) return { releaseDateFrom: null, releaseDateTo: null };

  const now = new Date();
  const shifted = () => new Date(now.getTime());
  // Upper bound for every "recent" window: today. A game can't have been
  // "released" in the future, so future-dated entries must be excluded —
  // otherwise a lower bound alone lets every upcoming release leak in.
  const today = toISODate(now);

  switch (token) {
    case "this_month": {
      const start = new Date(now.getFullYear(), now.getMonth(), 1);
      return { releaseDateFrom: toISODate(start), releaseDateTo: today };
    }
    case "6_months": {
      const d = shifted();
      d.setMonth(d.getMonth() - 6);
      return { releaseDateFrom: toISODate(d), releaseDateTo: today };
    }
    case "1_year": {
      const d = shifted();
      d.setFullYear(d.getFullYear() - 1);
      return { releaseDateFrom: toISODate(d), releaseDateTo: today };
    }
    case "5_years": {
      const d = shifted();
      d.setFullYear(d.getFullYear() - 5);
      return { releaseDateFrom: toISODate(d), releaseDateTo: today };
    }
    case "older": {
      const d = shifted();
      d.setFullYear(d.getFullYear() - 5);
      // Everything released before ~5 years ago.
      return { releaseDateFrom: null, releaseDateTo: toISODate(d) };
    }
    default:
      return { releaseDateFrom: null, releaseDateTo: null };
  }
}
